/**
 * Station Icons Configuration
 *
 * This file contains the mapping of station types to their respective icons.
 * Each icon is associated with a specific type of weather station.
 */

// Import all station icons
import communityIcon from "./weather-station(color).png"; // Current icon for community-led/cryologger/NTI
import officialIcon from "./weather-station(color).png"; // Icon for official community weather stations
import externalIcon from "./External-Source-Icon.png"; // Icon for ECCC stations

export const STATION_ICONS = {
  // Community-led, Cryologger Research, and NTI stations
  WIRL_Weather_Station: {
    icon: communityIcon,
  },
  NTI_Weather_Station: {
    icon: communityIcon,
  },
  Cryologger_Research_Station: {
    icon: communityIcon,
  },

  // Official community weather stations
  Official_Community_Station: {
    icon: officialIcon,
  },

  // ECCC stations
  ECCC_Weather_Station: {
    icon: externalIcon,
  },
};

// Default icon to use if station type is not found
export const DEFAULT_STATION_ICON = {
  icon: communityIcon,
};

/**
 * Get station icon configuration based on station type
 * @param {string} stationType - The type of the weather station
 * @returns {Object} Icon configuration object containing icon, label, and description
 */
export const getStationIcon = (stationType) => {
  return STATION_ICONS[stationType] || DEFAULT_STATION_ICON;
};
